import React, { useState } from 'react';
import { Divider, Modal, Tooltip, Typography } from 'antd';
import { requestform } from 'messages';
import { TicketDetail } from 'types';
import customerRequest from '../../assets/svg/customer-request.svg';
import img from '../../assets/images/logo.png';
import { conversation, InstalledAppIcon, NotInstalledAppIcon, TicketHistory } from 'assets';
import { ServerFileList } from 'components/common';
import { GetCustomerOTTInformation } from '../../hooks/customer-lookup/useCustomerReferenceInformation';
import ModalHistoryCreatingTicket from './Modal/ModalHistoryCreatingTicket';

interface ticketCreateInformation {
  requestItem: TicketDetail;
  isHistory?: boolean;
}

const RequestDetailMainInformation: React.FC<ticketCreateInformation> = ({ requestItem, isHistory = false }) => {
  const fieldValues = requestItem?.files?.map((file) => file.fileId) || [];
  // const shouldFetchOtt = requestItem?.customerCode && requestItem.customerCode !== 'khongdinhdanh';
  // const { ott } = shouldFetchOtt ? GetCustomerOTTInformation(requestItem.customerCode) : { ott: [] };
  const { ott } = GetCustomerOTTInformation(requestItem?.customerCode);

  const [isOpenHistoryModal, setIsOpenHistoryModal] = useState(false);
  const closeHistoryModal = () => setIsOpenHistoryModal(false);

  const checkOttStatus = (phoneNumber: string): React.ReactNode => {
    if (!ott || ott.length === 0 || !phoneNumber)
      return (
        <Tooltip title={requestform.notUsingEvnHcmInformation}>
          <div>
            <NotInstalledAppIcon className='h-5 w-5' />
          </div>
        </Tooltip>
      );
    const isLoggedIn = ott.some(
      (item: any) => item.phoneNumber === phoneNumber && (item.isLoginOTT === 1 || item.isLoginOTT === true)
    );
    // console.log('phoneNumber: ', phoneNumber);
    // console.log('ott: ', ott);
    // console.log('isLoggedIn: ', isLoggedIn);

    return isLoggedIn ? (
      <Tooltip title={requestform.usingEvnHcmInformation}>
        <div>
          <InstalledAppIcon className='h-5 w-5' />
        </div>
      </Tooltip>
    ) : (
      <Tooltip title={requestform.notUsingEvnHcmInformation}>
        <div>
          <NotInstalledAppIcon className='h-5 w-5' />
        </div>
      </Tooltip>
    );
  };

  return (
    <div className='max-w-4xl'>
      <Modal
        centered
        className='ant-modal-body-p-none min-w-[568px] rounded-xl bg-[#F5F4F6]'
        open={isOpenHistoryModal}
        onCancel={closeHistoryModal}
        footer={null}
        destroyOnClose
      >
        <div className='overflow-hidden'>
          <ModalHistoryCreatingTicket customerCode={requestItem.customerCode} />
        </div>
      </Modal>
      {/*
        Customer Information - Thong tin khach hang
      */}
      <div>
        <div className='flex items-center space-x-3'>
          <img src={img} className='h-8 w-8' alt='' />
          <Typography.Text className='text-[18px]/[22px] font-semibold text-[#141414]'>
            {requestform.customerInformationTitle}
          </Typography.Text>
        </div>
        {requestItem?.customer?.customerCode ? (
          <div className='space-y-2 pt-[20px]'>
            <div className='flex space-x-4'>
              <div className='w-[26%]'>
                <Typography.Text className='text-[16px]/[16px] text-[#6C737E]'>
                  {requestform.customerCode}
                </Typography.Text>
              </div>
              <div className='flex w-full justify-between'>
                <div className='flex space-x-6'>
                  <Typography.Text className='flex text-[16px]/[20px] text-[#141414]'>
                    {requestItem?.customer?.customerCode ? requestItem?.customer.customerCode : ''}
                  </Typography.Text>
                  {!isHistory && (
                    <Typography.Text className='text-[#1564E8]'>
                      {checkOttStatus(requestItem?.customer?.customerPhoneNumber)}
                    </Typography.Text>
                  )}
                </div>
                <div>
                  <Tooltip title={requestform.customerCreateTicketHistory}>
                    <div onClick={() => setIsOpenHistoryModal(true)} className='mr-4 flex hover:cursor-pointer'>
                      <TicketHistory className='mr-2 h-5 w-5' />
                      {requestform.requestHistory}
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>

            <div className='flex space-x-4'>
              <div className='w-[26%]'>
                <Typography.Text className='text-[16px]/[16px] text-[#6C737E]'>
                  {requestform.customerName}
                </Typography.Text>
              </div>
              <div className='flex w-full justify-between'>
                <Tooltip title={requestItem?.customer?.customerName ? requestItem?.customer.customerName : ''}>
                  <Typography.Text className='w-[625px] truncate text-[16px]/[20px] text-[#141414]'>
                    {requestItem?.customer?.customerName ? requestItem?.customer.customerName : ''}
                  </Typography.Text>
                </Tooltip>
              </div>
            </div>

            <div className='flex space-x-4'>
              <div className='w-[26%]'>
                <Typography.Text className='text-[16px]/[16px] text-[#6C737E]'>
                  {requestform.customerPhone}
                </Typography.Text>
              </div>
              <div className='flex w-full justify-between'>
                {requestItem?.customer?.customerPhoneNumber && (
                  <Typography.Text className='flex gap-6 text-[16px]/[20px] text-[#141414]'>
                    {requestItem?.customer?.customerPhoneNumber ? requestItem?.customer?.customerPhoneNumber : ''}
                    <Typography.Text className='text-[#1564E8]'>
                      {checkOttStatus(requestItem?.customer?.customerPhoneNumber)}
                    </Typography.Text>
                  </Typography.Text>
                )}
              </div>
            </div>

            <div className='flex space-x-4'>
              <div className='w-[26%]'>
                <Typography.Text className='text-[16px]/[16px] text-[#6C737E]'>
                  {requestform.customerAddress}
                </Typography.Text>
              </div>
              <div className='flex w-full justify-between'>
                <Tooltip title={requestItem?.customer?.customerAddress}>
                  <Typography.Text className='w-[625px] flex-wrap text-[16px]/[20px] text-[#141414]'>
                    {requestItem?.customer?.customerAddress ? requestItem?.customer?.customerAddress : ''}
                  </Typography.Text>
                </Tooltip>
              </div>
            </div>

            <div className='flex gap-4'>
              <div className='flex w-[35%] gap-8'>
                <div className='w-1/2 min-w-[150px]'>
                  <Typography.Text className='text-[16px]/[16px] text-[#6C737E]'>
                    {requestform.meterSerialNumber}
                  </Typography.Text>
                </div>
                <Typography.Text className='min-w-[70px] text-[16px]/[20px] text-[#141414]'>
                  {requestItem?.customer?.meterSerialNumber ? requestItem?.customer?.meterSerialNumber : ''}
                </Typography.Text>
              </div>

              <div className='flex gap-4'>
                <div className={'w-fit min-w-[110px]'}>
                  <Typography.Text className='text-[16px]/[16px] text-[#6C737E]'>
                    {requestform.routeCode}
                  </Typography.Text>
                </div>
                <Typography.Text className='min-w-[100px] text-[16px]/[20px] text-[#141414]'>
                  {requestItem?.customer?.routeCode ? requestItem?.customer?.routeCode : ''}
                </Typography.Text>
              </div>
            </div>

            <div className='flex gap-4'>
              <div className='flex w-[35%] gap-8'>
                <div className='w-1/2 min-w-[150px]'>
                  <Typography.Text className='text-[16px]/[16px] text-[#6C737E]'>
                    {requestform.distributionStationCode}
                  </Typography.Text>
                </div>
                <div className='min-w-[70px] text-[16px]/[20px] text-[#141414]'>
                  <Typography.Text>
                    {requestItem?.customer?.distributionStationCode
                      ? requestItem?.customer?.distributionStationCode
                      : ''}
                  </Typography.Text>
                </div>
              </div>

              <div className='flex gap-4'>
                <div className={'w-fit min-w-[110px]'}>
                  <Typography.Text className='text-[16px]/[16px] text-[#6C737E]'>
                    {requestform.distributionStationName}
                  </Typography.Text>
                </div>
                <div className='text-[16px]/[20px] text-[#141414]'>
                  <Typography.Text>
                    {requestItem?.customer?.distributionStationName
                      ? requestItem?.customer?.distributionStationName
                      : ''}
                  </Typography.Text>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className='space-y-2 pt-[20px]'>
            <Typography.Text className='text-nowrap text-[16px]/[16px] text-[#6C737E]'>
              Khách hàng chưa định danh
            </Typography.Text>
          </div>
        )}
      </div>

      {/*
        Request Information - Thong tin nguoi yeu cau
      */}
      <Divider className='mt-[20px] bg-[#D4D8DE]' />
      <div>
        <div className='flex items-center space-x-3'>
          <img src={customerRequest} alt='' />
          <Typography.Text className='text-[18px]/[22px] font-semibold text-[#141414]'>
            {requestform.customerRequestInformationTitle}
          </Typography.Text>
        </div>
        <div className='space-y-2 pt-[20px]'>
          <div className='flex space-x-4'>
            <div className='w-[26%]'>
              <Typography.Text className='text-nowrap text-[16px]/[16px] text-[#6C737E]'>
                {requestform.customerRequestName}
              </Typography.Text>
            </div>
            <div className='flex w-full justify-between'>
              <Tooltip title={requestItem?.customerRequestName}>
                <Typography.Text className='w-[625px] truncate text-[16px]/[20px] text-[#141414]'>
                  {requestItem?.customerRequestName ? requestItem.customerRequestName : ''}
                </Typography.Text>
              </Tooltip>
            </div>
          </div>

          <div className='flex space-x-4'>
            <div className='w-[26%]'>
              <Typography.Text className='text-nowrap text-[16px]/[16px] text-[#6C737E]'>
                {requestform.customerRequestPhone}
              </Typography.Text>
            </div>
            <div className='flex w-full justify-between'>
              {requestItem?.customerRequestPhoneNumber && (
                <div className='flex space-x-6'>
                  <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
                    {requestItem?.customerRequestPhoneNumber ? requestItem.customerRequestPhoneNumber : ''}
                  </Typography.Text>
                  {/* <CheckOttStatus
                    requestData={requestItem?.customerRequestPhoneNumber}
                    phoneNumber={requestItem?.customerRequestPhoneNumber}
                  /> */}
                  <Typography.Text className='text-[#1564E8]'>
                    {checkOttStatus(requestItem?.customerRequestPhoneNumber)}
                  </Typography.Text>
                </div>
              )}
            </div>
          </div>

          {/*<div className='flex space-x-4'>*/}
          {/*  <div className='w-[26%]'>*/}
          {/*    <Typography.Text className='text-[16px]/[16px] text-[#6C737E] text-nowrap'>*/}
          {/*      {requestform.numberOfCalls}*/}
          {/*    </Typography.Text>*/}
          {/*  </div>*/}
          {/*  <div className='flex w-full justify-between'>*/}
          {/*    <Typography.Text className='text-[16px]/[20px] text-[#141414]'>*/}
          {/*      {requestItem?.numOfRequests ? requestItem.numOfRequests : ''}*/}
          {/*    </Typography.Text>*/}
          {/*  </div>*/}
          {/*</div>*/}

          <div className='flex space-x-4'>
            <div className='w-[26%]'>
              <Typography.Text className='text-nowrap text-[16px]/[16px] text-[#6C737E]'>
                {requestform.customerRequestAddress}
              </Typography.Text>
            </div>
            <div className='flex w-full justify-between'>
              <Tooltip title={requestItem?.customerRequestAddress}>
                <Typography.Text className='w-[625px] text-wrap text-[16px]/[20px] text-[#141414]'>
                  {requestItem?.customerRequestAddress ? requestItem?.customerRequestAddress : ''}
                </Typography.Text>
              </Tooltip>
            </div>
          </div>
          <div className='flex space-x-4'>
            <div className='w-[26%]'>
              <Typography.Text className='text-nowrap text-[16px]/[16px] text-[#6C737E]'>
                {requestform.districtAndWard}
              </Typography.Text>
            </div>
            <div className='flex w-full justify-between'>
              <Tooltip title={requestItem?.administrativeUnit?.administrativeUnitName}>
                <Typography.Text className='w-[625px] text-wrap text-[16px]/[20px] text-[#141414]'>
                  {requestItem?.administrativeUnit?.administrativeUnitName
                    ? requestItem?.administrativeUnit?.administrativeUnitName
                    : ''}
                </Typography.Text>
              </Tooltip>
            </div>
          </div>
        </div>

        <div className='space-y-2 pt-[10px]'>
          <div className='flex space-x-4'>
            <div className='w-[26%]'>
              <Typography.Text className='text-nowrap text-[16px]/[16px] text-[#6C737E]'>
                {requestform.customerRequestCIN}
              </Typography.Text>
            </div>
            <div className='flex w-full space-x-12'>
              <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
                {requestItem?.customerRequestCicNumber ? requestItem?.customerRequestCicNumber : ''}
              </Typography.Text>

              {requestItem?.customerRequestCicNumber && (
                <div className='flex space-x-1'>
                  <div className=''>
                    <Typography.Text className='text-nowrap text-[16px]/[16px] text-[#6C737E]'>
                      {requestform.dateOfIssue}:
                    </Typography.Text>
                  </div>
                  <div className='flex w-full justify-between'>
                    <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
                      {requestItem?.customerRequestCicIssueDate ? requestItem.customerRequestCicIssueDate : ''}
                    </Typography.Text>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='flex space-x-4'>
            <div className='w-[26%]'>
              <Typography.Text className='text-nowrap text-[16px]/[16px] text-[#6C737E]'>
                {requestform.placeOfIssue}
              </Typography.Text>
            </div>
            <div className='flex w-full justify-between'>
              <Tooltip title={requestItem?.customerRequestCicIssuePlace}>
                <Typography.Text className='w-[625px] truncate text-[16px]/[20px] text-[#141414]'>
                  {requestItem?.customerRequestCicIssuePlace ? requestItem.customerRequestCicIssuePlace : ''}
                </Typography.Text>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
      <Divider className='mt-[20px] bg-[#D4D8DE]' />

      {/* File  */}
      <div>
        <Typography.Text className='text-[16px]/[16px] text-[#141414]'>{requestform.file}</Typography.Text>
        <div className='mt-3 flex space-x-1'>
          <ServerFileList
            isPreview
            fileList={fieldValues}
            itemProps={{ className: 'max-w-[40px] h-[60px]', showInfo: false }}
          ></ServerFileList>
        </div>
      </div>
      <Divider className='mt-[20px] bg-[#D4D8DE]' />

      {/* Request Content */}
      <div>
        <div className='flex items-center space-x-3'>
          <img src={conversation} alt='' />
          <Typography.Text className='text-[18px]/[22px] font-semibold text-[#141414]'>
            {requestform.requestContentTitle}
          </Typography.Text>
        </div>
        <div className='mt-[20px] rounded-lg bg-[#DDDDDD] p-3'>
          <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
            {requestItem?.content ? requestItem.content : ''}
          </Typography.Text>
        </div>
      </div>
      <Divider className='mt-[20px] bg-[#D4D8DE]' />

      {/*Resolution */}
      {requestItem?.status.code === 'HOANTAT' && (
        <>
          <div>
            <div className='flex items-center space-x-3'>
              <img src={conversation} alt='' />
              <Typography.Text className='text-[18px]/[22px] font-semibold text-[#141414]'>
                {requestform.resolutionTitle}
              </Typography.Text>
            </div>

            <div className='mt-[20px] min-w-[800px] rounded-lg bg-[#DDDDDD] p-3'>
              <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
                {requestItem?.resolution ? requestItem.resolution : ''}
              </Typography.Text>
            </div>
          </div>
          <Divider className='mt-[20px] bg-[#D4D8DE]' />
        </>
      )}
    </div>
  );
};

export default RequestDetailMainInformation;
